import type { LawyerCardDto } from '@lex/contracts';
import { PersonIcon } from '../icons';
import { Chip, Glow, SectionHeader } from './primitives';

function LawyerCard({ lawyer }: { lawyer: LawyerCardDto }) {
  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-line bg-white p-7">
      <div className="flex items-center gap-3">
        {lawyer.photoUrl ? (
          <img
            src={lawyer.photoUrl}
            alt={lawyer.name}
            className="h-20 w-20 rounded-2xl object-cover"
            loading="lazy"
          />
        ) : (
          <span className="flex h-20 w-20 items-center justify-center rounded-2xl bg-soft-gradient text-accent">
            <PersonIcon className="h-12 w-12" />
          </span>
        )}
        {lawyer.online ? (
          <span className="inline-flex items-center gap-1.5 rounded-lg bg-success-soft px-2.5 py-1 text-[12px] font-semibold text-success">
            <span className="h-1.5 w-1.5 rounded-full bg-success" />
            онлайн
          </span>
        ) : null}
      </div>

      <div className="flex flex-col gap-1">
        <span className="text-[22px] font-semibold tracking-[-0.005em] text-ink md:text-[24px]">
          {lawyer.name}
        </span>
        {lawyer.title ? (
          <span className="text-[15px] text-muted md:text-base">{lawyer.title}</span>
        ) : null}
      </div>

      {lawyer.specializations.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {lawyer.specializations.map((tag) => (
            <Chip key={tag}>{tag}</Chip>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export function LawyersSection({ lawyers }: { lawyers: LawyerCardDto[] }) {
  return (
    <section id="lawyers" className="scroll-mt-24 relative overflow-hidden px-4 py-14 md:px-8 md:py-20 xl:px-20">
      <Glow color="blue" size={420} opacity={0.16} blur={70} className="-left-24 top-24 hidden lg:block" />
      <Glow color="gold" size={420} opacity={0.16} blur={70} className="right-0 top-32 hidden lg:block" />

      <div className="relative mx-auto flex max-w-[1280px] flex-col gap-10 md:gap-12">
        <SectionHeader
          eyebrow="Юристы"
          title="Практикующие юристы, а не колл-центр"
          subtitle="Каждый профильный специалист ведёт свою категорию дел — от призыва до выплат и обжалований."
        />

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {lawyers.map((lawyer) => (
            <LawyerCard key={lawyer.id} lawyer={lawyer} />
          ))}
        </div>
      </div>
    </section>
  );
}
